import React from 'react'

function Divider({classname}) {
  return (
    <div className={`divider ${classname}`} />
  )
}

export default Divider